import React from 'react';
import './Community.css';

const STATS = [
  { num: 'CNCF', label: 'Chapter organizer' },
  { num: 'JO', label: 'Jordan chapter' },
  { num: 'K8s', label: 'Core focus' },
  { num: '2025', label: 'Chapter founded' },
];

function Community() {
  return (
    <section id="community" className="spine-layout">
      <div className="spine-col">
        <span>Community</span>
      </div>
      <div className="section-inner">
        <div className="sec-head">
          <h2 className="sec-title">Community</h2>
          <span className="sec-num">03 / 03</span>
        </div>
        <div className="community-row">
          <div className="community-text">
            <div className="community-label">Cloud Native Computing Foundation</div>
            <h3 className="community-heading">
              Growing Jordan's cloud native community from the ground up
            </h3>
            <p className="community-desc">
              I run the CNCF Jordan Chapter — organising meetups, workshops and honest
              conversations about Kubernetes, GitOps and what modern DevOps actually
              looks like in practice. The goal is simple: help engineers in Jordan
              learn from each other and go further together.
            </p>
          </div>
          <div className="community-stats">
            {STATS.map((s, i) => (
              <div key={i} className="cncf-stat">
                <div className="cncf-stat-num">{s.num}</div>
                <div className="cncf-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Community;
